import React from 'react';
import { LayoutDashboardIcon, CalendarIcon, UsersIcon, SettingsIcon, LogOutIcon, SparklesIcon, ChevronLeftIcon, LayoutIcon, MicIcon, AwardIcon, UserCircleIcon, ShieldIcon, NetworkIcon, MailIcon } from 'lucide-react';
interface AdminSidebarProps {
  currentLevel: 'portfolio' | 'master' | 'sub';
  onNavigate: (page: string) => void;
  onLogout: () => void;
  onBackToPortfolio?: () => void;
  onBackToMaster?: () => void;
  activePage: string;
}
export function AdminSidebar({
  currentLevel,
  onNavigate,
  onLogout,
  onBackToPortfolio,
  onBackToMaster,
  activePage
}: AdminSidebarProps) {
  const getMenuItems = () => {
    if (currentLevel === 'portfolio') {
      return [{
        id: 'portfolio',
        label: 'Events',
        icon: LayoutDashboardIcon
      }, {
        id: 'admin-users',
        label: 'Admin Users',
        icon: ShieldIcon
      }, {
        id: 'settings',
        label: 'Settings',
        icon: SettingsIcon
      }];
    }
    if (currentLevel === 'master') {
      return [{
        id: 'dashboard',
        label: 'Event Dashboard',
        icon: LayoutDashboardIcon
      }, {
        id: 'users',
        label: 'App Users',
        icon: UserCircleIcon
      }, {
        id: 'exhibitors',
        label: 'Exhibitors',
        icon: UsersIcon
      }, {
        id: 'sponsors',
        label: 'Sponsors',
        icon: AwardIcon
      }, {
        id: 'agenda',
        label: 'Agenda',
        icon: CalendarIcon
      }, {
        id: 'networking',
        label: 'Networking',
        icon: NetworkIcon
      }, {
        id: 'invitations',
        label: 'Invitations & Events',
        icon: MailIcon
      }, {
        id: 'settings',
        label: 'Event Settings',
        icon: SettingsIcon
      }];
    }
    // Sub-event level - only Feed and Settings
    return [{
      id: 'feed',
      label: 'Feed Management',
      icon: LayoutIcon
    }, {
      id: 'settings',
      label: 'Settings',
      icon: SettingsIcon
    }];
  };
  const menuItems = getMenuItems();
  return <div className="w-64 bg-gray-900 text-white h-screen flex flex-col fixed left-0 top-0 z-30" data-id="element-177">
      {/* Logo */}
      <div className="p-6 border-b border-gray-800" data-id="element-178">
        <div className="flex items-center gap-2" data-id="element-179">
          <SparklesIcon className="w-6 h-6 text-purple-500" data-id="element-180" />
          <div data-id="element-181">
            <h1 className="text-xl font-bold" data-id="element-182">ShowPilot</h1>
            <p className="text-xs text-gray-400" data-id="element-183">Admin Portal</p>
          </div>
        </div>
      </div>

      {/* Back Navigation */}
      {currentLevel !== 'portfolio' && <div className="p-4 border-b border-gray-800" data-id="element-184">
          <button onClick={currentLevel === 'sub' ? onBackToMaster : onBackToPortfolio} className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors" data-id="element-185">
            <ChevronLeftIcon className="w-4 h-4" data-id="element-186" />
            Back to {currentLevel === 'sub' ? 'Event' : 'Portfolio'}
          </button>
        </div>}

      {/* Navigation */}
      <nav className="flex-1 p-4" data-id="element-187">
        <div className="space-y-1" data-id="element-188">
          {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = activePage === item.id;
          return <button key={item.id} onClick={() => onNavigate(item.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`} data-id="element-189">
                <Icon className="w-5 h-5" data-id="element-190" />
                <span className="font-medium" data-id="element-191">{item.label}</span>
              </button>;
        })}
        </div>
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-800" data-id="element-192">
        <button onClick={onLogout} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-400 hover:bg-gray-800 hover:text-white transition-colors" data-id="element-193">
          <LogOutIcon className="w-5 h-5" data-id="element-194" />
          <span className="font-medium" data-id="element-195">Logout</span>
        </button>
      </div>
    </div>;
}